export var networkMap = {
  'ig-business': 'instagram',
  instagram: 'instagram',
  facebook: 'facebook',
  twitter: 'twitter',
  none: 'none'
};